import React, { useContext, useEffect, useState } from 'react'

import Cards from '../Cards/Cards'
import EquipSelect from './subComponents/EquipSelect'
import EquipmentModal from './subComponents/EquipmentModal'

import './equipementTabModal.scss'

import { CharacterContext } from '../../contexts/character'
import { DBContext } from '../../contexts/databases'

import * as jobsID from '../../data/jobID'
import { collectComboAegisNames } from '../../constants/combo'

function EquipementTabModal(props) {
	const { job, changeEquipSets, inventory, maxRefine } =
		useContext(CharacterContext)
	const { item_db_equip, item_combos } = useContext(DBContext)
	const [equip, setEquip] = useState([])
	const [shadowEquip, setShadowEquip] = useState([])
	const [currentLocation, setCurrentLocation] = useState('Head_Top')
	const [modalIsOpen, setIsOpen] = React.useState(false)

	function openModal() { setIsOpen(true) }
	function closeModal() { setIsOpen(false) }

	useEffect(() => {
		changeEquipSets(
			item_combos.filter((combos) =>
				combos.Combos.find((combo) =>
					combo.Combo.every((comb) =>
						collectComboAegisNames(inventory).includes(comb),
					),
				),
			),
		)
		setEquip([
			inventory['Head_Top'],
			inventory['Head_Mid'],
			inventory['Head_Low'],
			inventory['Armor'],
			inventory['Right_Hand'],
			inventory['Left_Hand'],
			inventory['Garment'],
			inventory['Shoes'],
			inventory['Right_Accessory'],
			inventory['Left_Accessory'],
		])
		setShadowEquip([
			inventory['Shadow_Weapon'],
			inventory['Shadow_Shield'],
			inventory['Shadow_Armor'],
			inventory['Shadow_Shoes'],
			inventory['Shadow_Right_Accessory'],
			inventory['Shadow_Left_Accessory'],
		])
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inventory, item_combos])

	return (
		<div className={'equipementTabModalMainContainer ' + props.className}>
			<div className='equipementTabModal'>
				<div className='Gears'>
					{Object.keys(equip).map((key) =>
						displayInventory(
							props,
							equip,
							key,
							maxRefine,
							openModal,
							setCurrentLocation,
							closeModal,
						),
					)}
				</div>
				<div className='shadow-section-label'>Shadow Gear</div>
				<div className='ShadowGears'>
					{Object.keys(shadowEquip).map((key) =>
						displayInventory(
							props,
							shadowEquip,
							key,
							maxRefine,
							openModal,
							setCurrentLocation,
							closeModal,
						),
					)}
				</div>
				<EquipmentModal
					location={currentLocation}
					itemList={filterItems(item_db_equip, currentLocation, job)}
					modalIsOpen={modalIsOpen}
					closeModal={closeModal}
					setLastSelectedItem={props.setLastSelectedItem}
					lastSelectedItem={props.lastSelectedItem}
				/>
			</div>
		</div>
	)
}

function displayInventory(
	props,
	equip,
	key,
	maxRefine,
	openModal,
	setCurrentLocation,
	closeModal,
) {
	return (
		<div className='horizontal' key={equip[key].Location}>
			<Cards
				Name={equip[key].Location}
				openModal={openModal}
				closeModal={closeModal}
				setLocation={setCurrentLocation}
				seachMode={true}
			>
				<EquipSelect
					id={equip[key].Location}
					Location={equip[key].Location}
					Refinable={equip[key].isRefinable}
					MaxRefine={maxRefine[equip[key].Location]}
					setLastSelectedItem={props.setLastSelectedItem}
				/>
			</Cards>
		</div>
	)
}

function filterItems(item_db_equip, Location, job) {
	let Location2 = Location
	if (Location === 'Right_Accessory' || Location === 'Left_Accessory')
		Location2 = 'Both_Accessory'
	if (Location === 'Right_Hand') Location2 = 'Both_Hand'
	let formatedBaseClassName = jobsID.getFormatedBaseClassName(job)
	let gender = ''
	if (
		formatedBaseClassName === 'Bard' ||
		formatedBaseClassName === 'Dancer'
	) {
		gender = formatedBaseClassName === 'Bard' ? 'Male' : 'Female'
		formatedBaseClassName = 'BardDancer'
	}
	if (formatedBaseClassName === 'Star_Gladiator')
		formatedBaseClassName = 'StarGladiator'
	if (formatedBaseClassName === 'Soul_Linker')
		formatedBaseClassName = 'SoulLinker'

	return item_db_equip.filter(
		(eq) =>
			(eq.Locations?.[Location] || eq.Locations?.[Location2]) &&
			(!eq.Jobs || eq.Jobs?.[formatedBaseClassName]) &&
			(!eq.Gender || eq.Gender === gender),
	)
}

export default EquipementTabModal
